module.exports = __webpack_public_path__ + "img/picada.f6868392.jpg";